import { Component } from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { BaseComponent } from 'src/app/core/base/base.component';
import { DOCTOR } from '../doctor.constants';
import { DoctorService } from '../doctor.service';
import { DoctorDialogComponent } from './doctor-dialog.component';
import { CommonDoctorViewModel } from 'src/app/model/common/doctor.view';

@Component({
  selector: 'ms-common-doctor',
  templateUrl: './doctor-main.component.html'
})
export class DoctorMainComponent extends BaseComponent {

  readonly screen = DOCTOR;
  protected setScreen = true;
  doctors: VonPageResponseModel<CommonDoctorViewModel> = {} as VonPageResponseModel<CommonDoctorViewModel>;
  selectedDoctor: CommonDoctorViewModel = {};
  options: MenuItem[] = [];
  dtDocumentFilter?: string;
  dtNameFilter?: string;

  constructor(
    protected service: DoctorService
  ) {
    super();
  }

  onInit = () => {
    this.loading = true;
    this.subscriptions.push(
      this.service.readDoctorLazyLoad().subscribe(doctors => this.doctors = doctors)
    );
    this.setDefaultContextMenu();
  }

  openModal = (isNew: boolean = true) =>
    this.service.openDoctorDialog(isNew, DoctorDialogComponent)

  lazyReadDoctors = ($event: LazyLoadEvent) => {
    this.service.setLoadingState();
    const page = $event.first! / $event.rows!;
    this.subscriptions.push(
      this.service.getDoctors(page, $event.rows!, $event.filters!.fullName, $event.filters!.document).subscribe()
    );
  }

  setContextMenuItems = () => {
    const idx = this.options.findIndex(op => op.id === 'enableDisable');
    this.options[idx] = {
      ...this.options[idx],
      label: this.screen.actions[this.selectedDoctor.status ? 'disable' : 'enable'],
      styleClass: `text-${this.selectedDoctor.status ? 'danger' : 'success'}`,
      icon: `far ${this.selectedDoctor.status ? 'fa-trash-alt' : 'fa-check-circle'}`
    };

    const passIdx = this.options.findIndex(op => op.id === 'pass');
    this.options[passIdx] = {
      ...this.options[passIdx],
      visible: this.selectedDoctor.username != null
    };
  }

  private setDefaultContextMenu = () => {
    this.options.push({
      id: 'edit',
      label: this.screen.actions.edit,
      styleClass: 'text-warning',
      icon: 'fas fa-pencil-alt',
      command: _ => this.subscriptions.push(
        this.service.getDoctorById(this.selectedDoctor.id!).subscribe(
          doctor => {
            this.subscriptions.push(
              this.service.getPersonById(doctor.person!).subscribe()
            );
            this.openModal(false);
          }
        )
      )
    });

    this.options.push({
      id: 'pass',
      styleClass: 'text-success',
      icon: 'fas fa-unlock-alt',
      label: this.screen.actions.generatePass,
      command: _ => this.service.generatePass(this.selectedDoctor.username!, this.selectedDoctor.fullName!)
    });

    this.options.push({
      id: 'specialties',
      styleClass: 'text-info',
      icon: 'fas fa-exchange-alt',
      label: this.screen.actions.setSpecialties,
      command: _ => this.service.openManageSpecialtiesDialog(this.selectedDoctor)
    });

    this.options.push({
      id: 'enableDisable',
      label: this.screen.actions.disable,
      styleClass: 'text-danger',
      icon: 'far fa-trash-alt',
      command: _ => this.service.changeStatus(this.selectedDoctor.id!, !this.selectedDoctor.status, this.selectedDoctor.fullName!)
    });

    this.options.push({
      id: 'setRole',
      label: this.screen.actions.roleCounter,
      styleClass: 'text-success',
      icon: 'fas fa-user-tag',
      command: _ => this.service.setRole('counter', this.screen.actions.roleCounter, this.selectedDoctor)
    });

    this.options.push({
      id: 'setRole',
      label: this.screen.actions.roleVitalSign,
      styleClass: 'text-success',
      icon: 'fas fa-user-tag',
      command: _ => this.service.setRole('vital-sign', this.screen.actions.roleVitalSign, this.selectedDoctor)
    });

    this.options.push({
      id: 'setRole',
      label: this.screen.actions.roleDoctor,
      styleClass: 'text-success',
      icon: 'fas fa-user-tag',
      command: _ => this.service.setRole('doctor', this.screen.actions.roleDoctor, this.selectedDoctor)
    });
  }

}
